module.exports = __webpack_public_path__ + "img/bg-blue-plant.498bd99b.png";